module.exports = __webpack_public_path__ + "static/img/call-pass.d258b92c.webp";